import { RefObject, useEffect } from 'react';

interface IParams {
  isOpen: boolean;
  ref: RefObject<HTMLElement>;
  handler: (e: Event) => any;
}
export function useCloseEventHandler({ isOpen, ref, handler }: IParams) {
  useEffect(() => {
    function listener(e: MouseEvent) {
      if (!ref.current || ref.current.contains(e.target as Node)) {
        return;
      }
      handler(e);
    }
    function keyListener(e: KeyboardEvent) {
      const ESC = 27;
      if (e.keyCode === ESC && isOpen) {
        handler(e);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      document.addEventListener('focusin', listener);
      document.addEventListener('keydown', keyListener);
    }

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('focusin', listener);
      document.removeEventListener('keydown', keyListener);
    };
  }, [isOpen, ref, handler]);
}
